if (window.__POWERED_BY_QIANKUN__) {
  window['custom-append-child'] = {
    'document.head.appendChild': document.head.appendChild,
    'document.head.insertBefore': document.head.insertBefore,
    'document.body.appendChild': document.body.appendChild,
    'document.body.insertBefore': document.body.insertBefore,
  }

  function applyHandler(node, next) {
    const conditions = {
      // 使用 https://at.alicdn.com/t/c/**/* 引入的 iconfont 图标默认只添加在了主系统的 DOM 没有添加到子系统的 DOM , 导致子系统的 icon 无法显示 (子系统基于 shadow dom 隔离,无法访问主系统)
      // 通过梳理发现 iconfont 图标是通过 insertBefore || document.body.appendChild 方法把 svg 节点添加到 DOM 里的
      // 而 document.body.appendChild 这个情况不需要考虑, 因为调用这个方法逻辑是 body 内没有节点, 如果不是子系统, body 中始终有 #root 节点; 如果是子系统, body 在主系统中始终存在, 所以不需要考虑
      // 如果是来自 iconfont 的节点, 拦截插入行为
      isIconfont: node instanceof SVGElement && node.ariaHidden === 'true',
      // 可补充其他有节点副作用的条件, 比如某个节点会插入到主系统的body中, 期望是插入到子系统中
    }
    if (Object.values(conditions).some((bool) => bool)) {
      // 拦截此次插入行为, 触发事件以在未来的时刻进行自定义处理
      window.delayedEventBus.emit('custom-append-child', node, next, conditions)
      return null
    }
    // 否则调用原本方法, 该怎么插入就怎么插入
    return next()
  }
  const proxy = {
    apply(target, thisArg, argArray) {
      const next = () => target.apply(thisArg, argArray)
      return applyHandler(argArray[0], next)
    },
  }
  // 以下是 DOM 中常见的插入节点的方法, 以及被 qiankun 代理的方法
  // 不能代理 `Node.prototype.appendChild` 这会导致无法覆盖 qiankun 代理的方法, 在使用 document.[body|head|...].[appendChild|insertBefore|...] 方法时无法被自己的代理拦截
  document.head.appendChild = new Proxy(document.head.appendChild, proxy)
  document.head.insertBefore = new Proxy(document.head.insertBefore, proxy)
  document.body.appendChild = new Proxy(document.body.appendChild, proxy)
  document.body.insertBefore = new Proxy(document.body.insertBefore, proxy)

  // 清理函数, unmount 时调用, 防止污染全局
  window['custom-append-child'].cleanup = function () {
    document.head.appendChild = this['document.head.appendChild']
    document.head.insertBefore = this['document.head.insertBefore']
    document.body.appendChild = this['document.body.appendChild']
    document.body.insertBefore = this['document.body.insertBefore']
  }

  // 外部 js 文件只在第一次 mount 时执行, 后续 re-mount 不会执行, 导致 cleanup 后无法恢复
  window['custom-append-child'].reinstall = function () {
    // 判断是否被 cleanup 了, 防止重复代理
    if (document.head.appendChild === this['document.head.appendChild']) {
      document.head.appendChild = new Proxy(document.head.appendChild, proxy)
    }
    if (document.head.insertBefore === this['document.head.insertBefore']) {
      document.head.insertBefore = new Proxy(document.head.insertBefore, proxy)
    }
    if (document.body.appendChild === this['document.body.appendChild']) {
      document.body.appendChild = new Proxy(document.body.appendChild, proxy)
    }
    if (document.body.insertBefore === this['document.body.insertBefore']) {
      document.body.insertBefore = new Proxy(document.body.insertBefore, proxy)
    }
  }
}
